import { render } from "./TheSeccoundAside.vue?vue&type=template&id=123af717&scoped=true"
import script from "./TheSeccoundAside.vue?vue&type=script&lang=js"
export * from "./TheSeccoundAside.vue?vue&type=script&lang=js"

import "./TheSeccoundAside.vue?vue&type=style&index=0&id=123af717&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123af717"]])

export default __exports__